import { property as u } from "../beacon-property.d/index.js";
import { state as c } from "../beacon-state.d/index.js";
import { g as l } from "./uid-HAKIZOcY.js";
import { B as f } from "./abstract-base-DDNz9tUt.js";
var p = Object.defineProperty, n = (s, t, i, e) => {
  for (var r = void 0, a = s.length - 1, o; a >= 0; a--)
    (o = s[a]) && (r = o(t, i, r) || r);
  return r && p(t, i, r), r;
};
const m = "beacon-table";
class d extends f {
  constructor() {
    super(...arguments), this.isOriginal = !0, this.uuid = l();
  }
  /** When using transformed cards, this stores all nodes associated with the current one via their identical UUID. */
  get pairedNodes() {
    const { beaconTagName: t, uuid: i } = this, e = `[uuid="${i}"]`, r = `${this.getScopedTagName(t)}${e}`;
    if (this.isOriginal) {
      const a = this.closest(
        this.getScopedTagName(m)
      );
      if (!a) return;
      const o = a._transformedCardsContainer;
      return o ? Array.from(o.querySelectorAll(r)) : void 0;
    }
    return Array.from(document.querySelectorAll(r));
  }
  willUpdate(t) {
    t.forEach((i, e) => {
      this.pairedNodes && e !== "isOriginal" && (!this.isOriginal && e === "bold" || this.pairedNodes.forEach((r) => {
        e && (r[e] = i);
      }));
    });
  }
}
n([
  c()
], d.prototype, "isOriginal");
n([
  u({ reflect: !0 })
], d.prototype, "uuid");
export {
  d as B
};
